<template>
  <SettingsBox
    title="Ustawienia ogólne"
    description="Podstawowe informacje o jadłospisie i czasie jego trwania."
  >
    <Input
      test-id="DietDetailSettings__Name"
      class="name"
      label="Nazwa"
      :disabled="!editable"
      :required="true"
      :maxlength="85"
      helper-text="Widoczna dla pacjenta (w aplikacji i na wydruku PDF)."
      :model-value="name"
      placeholder="Kliknij, aby wprowadzić nazwę jadłospisu"
      @update:model-value="emit('update:name', $event)"
    />
    <Textarea
      class="description"
      label="Opis"
      :disabled="!editable"
      :maxlength="5000"
      :model-value="description"
      helper-text="Widczony tylko dla Ciebie."
      placeholder="Kliknij, aby wprowadzić opis jadłospisu"
      @update:model-value="emit('update:description', $event)"
    />
    <Space class="days-count-field__controls" align-y="end" direction="columns" :space="7">
      <Input
        test-id="DietDetailSettings__DaysCount"
        class="days-count-field__input"
        label="Długość jadłospisu"
        :model-value="daysCount"
        readonly
        required
        :disabled="!canChange"
      >
        <template #suffix>dni</template>
      </Input>
      <Tooltip placement="top-start" :disabled="canChange">
        <template #trigger>
          <Button color="gray" :disabled="!canChange" @click="emit('change')">
            <template #leftIcon><Icon name="Edit05" /></template>
            Edytuj
          </Button>
        </template>
        Jadłospis ma przypisane daty, nie możesz zmienić jego długości.
      </Tooltip>
    </Space>
  </SettingsBox>
</template>

<script lang="ts" setup>
  import { Space } from '@/components/Space'
  import { Button, Icon, Input, Textarea, Tooltip } from '@/components/ui'

  import type { DietType } from '@/store/types'

  import { SettingsBox } from '../SettingsBox'

  defineProps<{
    description: string
    dietType?: DietType
    editable: boolean
    name: string
    daysCount: number
    canChange: boolean
    hasDates: boolean
  }>()
  const emit = defineEmits<{
    'update:description': [value: string]
    'update:name': [value: string]
    change: []
  }>()
</script>
